@let level = titleLevel();
@let class = globalClass();

@if (isDescription()) {
  <p [class]="class">
    <ng-container *ngTemplateOutlet="content" />
  </p>
} @else if (level === 1) {
  <h1 [class]="class">
    <ng-container *ngTemplateOutlet="content" />
  </h1>
} @else if (level === 2) {
  <h2 [class]="class">
    <ng-container *ngTemplateOutlet="content" />
  </h2>
} @else if (level === 3) {
  <h3 [class]="class">
    <ng-container *ngTemplateOutlet="content" />
  </h3>
} @else if (level === 4) {
  <h4 [class]="class">
    <ng-container *ngTemplateOutlet="content" />
  </h4>
} @else if (level === 5) {
  <h5 [class]="class">
    <ng-container *ngTemplateOutlet="content" />
  </h5>
} @else if (level === 6) {
  <h6 [class]="class">
    <ng-container *ngTemplateOutlet="content" />
  </h6>
} @else {
  <p [class]="class">
    <ng-container *ngTemplateOutlet="content" />
  </p>
}

<ng-template #content><ng-content /></ng-template>
